export function hydrateAndLinkJobTypes(jobTypes)
{
    // hydrate JobType objects + link them
    for (const [id, jsonJobType] of Object.entries(jobTypes)) {
        jobTypes[id] = new JobType(jsonJobType);
    }
    for (const [id, jobType] of Object.entries(jobTypes)) {
        if (jobType.parentId !== null) {
            jobType.parent = jobTypes[jobType.parentId];
        } else {
            jobType.parent = null;
        }
        jobType.children = jobType.childrenIds.map(childId => jobTypes[childId]);
    }
}

export class JobType
{
    constructor(jsonJobType) {
        this.id = jsonJobType.id;
        this.name = jsonJobType.name;
        this.color = jsonJobType.color;
        this.order = jsonJobType.order;
        this.defaultUrgencyLevel = jsonJobType.defaultUrgencyLevel;
        this.isOther = jsonJobType.isOther; // 'isOther' is not included in api call from PelicanBundle, only from WorkerInterfaceBundle
        this.parentId = jsonJobType.parentId;
        this.childrenIds = [...jsonJobType.children]; // array shallow copy
        this.hasMaxPartnerPriceData = jsonJobType.hasMaxPartnerPriceData;
        this.maxPartnerPrice = jsonJobType.maxPartnerPrice;
        this.isSpecificSkill = jsonJobType.isSpecificSkill;
        this.minHopeMultiplier = jsonJobType.minHopeMultiplier;
        this.maxHopeMultiplier = jsonJobType.maxHopeMultiplier;
        this.normalCostPrice = jsonJobType.normalCostPrice;
        this.normalCostBasePrice = jsonJobType.normalCostBasePrice;
        this.iconsOfJobTypeService = jsonJobType.iconsOfJobTypeService;
        this.translationOfJobTypeService = jsonJobType.translationOfJobTypeService;
        // this.parent and this.children will be added by 'JobTypeApi'
    }

    isRoot() {
        return this.parent === null;
    }

    isLeaf() {
        return this.children.length === 0;
    }

    isChildThisOrAncestorOf(jobType) {
        return (
            this.parent === jobType
            || this.isThisOrAncestorOf(jobType)
        );
    }

    isThisOrAncestorOf(jobType) {
        return (
            this === jobType
            || this.isAncestorOf(jobType)
        );
    }

    getRoot() {
        if (this.isRoot()) {
            return this;
        }
        return this.parent.getRoot();
    }

    getAncestorsChain() {
        if (this.isRoot()) {
            return [this];
        }
        const chain = this.parent.getAncestorsChain();
        chain.push(this);
        return chain;
    }

    isAncestorOf(jobType) {
        if (jobType.isRoot()) {
            return false;
        }
        if (jobType.parent === this) {
            return true;
        }
        return this.isAncestorOf(jobType.parent);
    }
}
